/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Activity } from './Activity';
import {
    ActivityFromJSON,
    ActivityFromJSONTyped,
    ActivityToJSON,
} from './Activity';
import type { PlaylistWithoutTracks } from './PlaylistWithoutTracks';
import {
    PlaylistWithoutTracksFromJSON,
    PlaylistWithoutTracksFromJSONTyped,
    PlaylistWithoutTracksToJSON,
} from './PlaylistWithoutTracks';

/**
 * 
 * @export
 * @interface CollectionActivityWithoutTracks
 */
export interface CollectionActivityWithoutTracks extends Activity {
    /**
     * 
     * @type {string}
     * @memberof CollectionActivityWithoutTracks
     */
    itemType: CollectionActivityWithoutTracksItemTypeEnum;
    /**
     * 
     * @type {PlaylistWithoutTracks}
     * @memberof CollectionActivityWithoutTracks
     */
    item: PlaylistWithoutTracks;
}


/**
 * @export
 */
export const CollectionActivityWithoutTracksItemTypeEnum = {
    Playlist: 'playlist'
} as const;
export type CollectionActivityWithoutTracksItemTypeEnum = typeof CollectionActivityWithoutTracksItemTypeEnum[keyof typeof CollectionActivityWithoutTracksItemTypeEnum];


/**
 * Check if a given object implements the CollectionActivityWithoutTracks interface.
 */
export function instanceOfCollectionActivityWithoutTracks(value: object): value is CollectionActivityWithoutTracks {
    let isInstance = true;
    isInstance = isInstance && "itemType" in value && value["itemType"] !== undefined;
    isInstance = isInstance && "item" in value && value["item"] !== undefined;

    return isInstance;
}

export function CollectionActivityWithoutTracksFromJSON(json: any): CollectionActivityWithoutTracks {
    return CollectionActivityWithoutTracksFromJSONTyped(json, false);
}

export function CollectionActivityWithoutTracksFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectionActivityWithoutTracks {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ActivityFromJSONTyped(json, ignoreDiscriminator),
        'itemType': json['item_type'],
        'item': PlaylistWithoutTracksFromJSON(json['item']),
    };
}

export function CollectionActivityWithoutTracksToJSON(value?: CollectionActivityWithoutTracks | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ActivityToJSON(value),
        'item_type': value.itemType,
        'item': PlaylistWithoutTracksToJSON(value.item),
    };
}

